import React from 'react';
import { componentsRedux } from 'redux/reusable';
import { useFlowratesSubQuerys } from 'apollo/filter-flowrates';

const Subqueries = (props) => {
  const { yearStart, yearEnd, weekStart, weekEnd } = props;
  const { data, loading } = useFlowratesSubQuerys({
    yearStart,
    yearEnd,
    weekStart,
    weekEnd,
  });
  return <>{props.children({ loading, data: data.Subqueries })}</>;
};

export default componentsRedux(Subqueries);
